//* https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/components/tooltip.ts

import { StyleConfig } from '_types';

export const Tooltip: StyleConfig = {
  baseStyle: (props) => {
    const { _colorScheme, colorMode } = props;

    return {
      bg:
        colorMode === 'dark'
          ? 's-icon-neutral-hovered'
          : 's-icon-neutral-hovered',
      color: colorMode === 'dark' ? '#ffffff' : '#ffffff',
    };
  },

  sizes: {},

  variants: {},
};
